<template>
  <router-link
    v-if="data"
    to="/"
    class="editorial-card"
  >
    <img :src="data.display_image_url">
    <p>{{ data.title | truncate(25) }}</p>
  </router-link>
</template>
<script>
export default {
  name: 'EditorialCarousel',
  props: {
    data: {
      type: Object,
      default() {
        return {
          display_image_url: '',
          title: '',
        };
      },
    },
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="scss" scoped>
 .editorial-card {
   height: 300px;
   position: relative;
   display: block;
   margin:15px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index:1;
      border-radius: 10px;
      filter: brightness(.7);
    }
    p {
      position: absolute;
      top:10px;
      left:10px;
      color: #fff;
      font-size: 22px;
      z-index:3;
    }
 }
</style>



// WEBPACK FOOTER //
// app/src/components/EditorialCard.vue